// Wraps localStorage in try/catch — Safari private mode, embedded WebViews
// with storage disabled, and quota-exceeded all throw on access. Falls back
// to a per-key in-memory map so the calling feature stays functional for
// the session even when the browser refuses to persist.

const memory = new Map<string, string>();

export function safeGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    // localStorage threw — fall back to the in-memory cache populated by
    // safeSet. We do NOT fall back when getItem returns null without
    // throwing, because that legitimately means "no value stored".
    return memory.get(key) ?? null;
  }
}

export function safeSet(key: string, value: string): void {
  memory.set(key, value);
  try {
    window.localStorage.setItem(key, value);
  } catch {
    console.warn(`[safeStorage] localStorage unavailable for "${key}"; using in-memory fallback`);
  }
}

export function safeRemove(key: string): void {
  memory.delete(key);
  try {
    window.localStorage.removeItem(key);
  } catch {
    // Already removed from memory; storage write failure is non-fatal.
  }
}
